import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link} from "react-router-dom";
import {
  petroleumData,
  petroleumcard,
  articles,
  mainNews,
} from "../content/content";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Whychoseus = () => {
  const navigate = useNavigate();
  const containerRef = useRef(null);

  useEffect(() => {
    // Ensure the elements exist before running animations
    const timeout = setTimeout(() => {
      if (!containerRef.current) return;

      const elements = containerRef.current.querySelectorAll(".animate");

      elements.forEach((el) => {
        gsap.from(el, {
          opacity: 0,
          y: 50,
          duration: 1.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
      });
    }, 100); // Adding slight delay to ensure DOM is ready

    return () => clearTimeout(timeout);
  }, []);

  const handleReadMore = (project) => {
    if (project.title === "CBG") {
      navigate("/synergy-dg");

    } else if (project.title === "DEF Dispensers") {
            navigate("/synergy-def-dispenser");

    } else if (project.title === "Fabrication Services") {
      navigate("/synergy-fabrication");
    } else {
      navigate(`/`);
    }
  };

  return (
    <div ref={containerRef}>
      <div className="flex flex-col md:flex-row items-center w-full mt-[-50px] px-4 py-6 animate">
        {/* Left Side - Images */}
        <div className="relative w-full md:w-1/2 flex flex-col items-center">
          <img
            src={petroleumData.mainImage}
            alt="Industrial plant"
            className="w-full md:w-11/12 h-72 md:h-96 object-cover"
          />
          <img
            src={petroleumData.overlayImage}
            alt="Oil plant"
            className="absolute bottom-[-30px] right-4 md:right-[-5px] w-2/4 md:w-2/4 border-4 border-[#dbcf29] rounded-lg shadow-lg"
          />
        </div>

        {/* Right Side - Content */}
        <div className="relative w-full md:w-1/2 mt-12 md:mt-0 p-4 md:p-8 animate">
          <h4 className="text-sm font-semibold text-gray-500">
            {petroleumData.title}
          </h4>
          <h2 className="text-xl md:text-2xl font-bold mt-2">
            {petroleumData.heading}
          </h2>
          <p className="text-gray-600 mt-4 text-sm md:text-base">
            {petroleumData.description}
          </p>

          {/* Progress Bars */}
          {petroleumData.progress.map((item, index) => (
            <div key={index} className="mt-6 animate">
              <div className="flex justify-between text-xs md:text-sm font-semibold mb-1">
                <span>{item.label}</span> <span>{item.value}%</span>
              </div>
              <div className="w-full bg-gray-300 h-2 rounded-full">
                <div
                  className="bg-yellow-500 h-2 rounded-full transition-all duration-300"
                  style={{ width: `${item.value}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-6 py-12 animate">
        {/* Title and Description */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-6">
          <div className="md:w-1/2">
            <h4 className="text-sm font-semibold text-gray-500">
              {petroleumcard.title}
            </h4>
            <h2 className="text-2xl md:text-4xl font-bold mt-2 leading-tight">
              {petroleumcard.heading}
            </h2>
          </div>
          <div className="md:w-1/3 text-gray-600">
            <p className="text-sm md:text-base">{petroleumcard.description}</p>
            <button className="mt-4 px-6 py-2 border-2 border-black font-semibold hover:bg-black hover:text-white transition-all">
              ALL PROJECT
            </button>
          </div>
        </div>

        {/* Project Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-12">
          {petroleumcard.projects.map((project, index) => (
            <div
              key={index}
              className="bg-white shadow-md overflow-hidden animate"
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-56 md:h-64 object-cover"
              />
              <div className="p-4">
                <h3 className="text-lg md:text-xl font-bold">
                  {project.title}
                </h3>
                <p className="text-gray-600 mt-2 text-sm md:text-base">
                  {project.description}
                </p>
                <button
                  onClick={() => handleReadMore(project)}
                  className="mt-4 px-4 py-2 bg-yellow-500 text-black font-bold hover:bg-yellow-600 transition-all"
                >
                  READ MORE
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="container mx-auto px-4 py-10 overflow-hidden animate">
          {/* Grid Container */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6"  >
            {/* Left Section - Main News */}
            
            <div className="md:col-span-2 bg-white shadow-lg w-full max-w-[100%] md:max-w-full mx-auto">
             
              <div className="relative">
                
                 <Link 
    to="/synergy-dg" 
    target="_blank" 
    rel="noopener noreferrer"
  >
                <img
                  src={mainNews.image}
                  alt="Main News"
                  className="w-full h-[200px] md:h-auto object-cover"
                /></Link>
                <span className="absolute top-2 right-2 bg-[#E7D70E] text-black text-xs md:text-sm font-bold px-3 py-2">
                  {mainNews.label}
                </span>
              </div>
              <div className="p-4 md:p-6">
                <Link 
    to="/synergy-dg" 
    target="_blank" 
    rel="noopener noreferrer"
  >
<h2 className="text-xl md:text-2xl font-bold">
                  {mainNews.title}
                </h2>
                <p className="text-gray-600 mt-2 text-sm md:text-base">
                  {mainNews.description}
                </p></Link>
                
              </div>
             
            </div>

            {/* Right Section - News List */}
            <div className="container mt-[-40px] mx-[-10px] md:mx-auto px-4 py-8">
              <h2 className="text-2xl font-bold">Our Projects</h2>
              {/* <p className="text-gray-600 mb-6">
                Latest updates from the industry
              </p> */}

              {/* Articles List */}
             <div className="space-y-6">
  {articles.map((article, index) => (
    <div
      key={index}
      className="flex flex-col sm:flex-row items-start bg-white shadow-md rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
    >
      <Link 
        to={article.link} 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex flex-col sm:flex-row w-full"
      >
        {/* Image Section */}
        <img
          src={article.image}
          alt={article.title}
          className="w-full sm:w-40 h-40 object-cover rounded-t-lg sm:rounded-l-lg sm:rounded-t-none"
        />

        {/* Content Section */}
        <div className="p-4 flex flex-col justify-between">
          <h3 className="text-lg md:text-xl font-semibold text-gray-800 hover:text-blue-600 transition-colors duration-200">
            {article.title}
          </h3>
          <p className="text-gray-600 mt-2 text-sm md:text-base">
            {article.description}
          </p>
        </div>
      </Link>
    </div>
  ))}
</div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Whychoseus;
